import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  SpaceBetween,
  Button,
  FormField,
  Input,
  Select,
  Spinner,
  SegmentedControl,
  Header,
  Alert,
  Table,
  ButtonDropdown,
  Container,
  Link
} from "@amzn/awsui-components-react";

import "src/Home/homepage.scss";

import { addBoardItem, getOwnersByOwnership, getOwnersForAdminUser } from "src/utilities/CloseAPIs";
import { useSelector } from "react-redux";
import { selectIsEffectiveAdmin, selectIsEffectiveSupportAdmin } from 'src/utilities/adminUtils';
import { configureGenericAppSync } from "src/context/AuthContextUtility";
import { createPreference, updatePreference, deletePreference, listPreference } from "src/utilities/AppSyncPlusAPIs";
import { closePortalDefaultTabs } from "../constants";

const AddToCPModal = ({
  visible,
  onDismiss,
  resourceURL
}) => {
  
  const [ownedTeams, setOwnedTeams] = useState([])
  const [selectedTeam, setSelectedTeam] = useState()
  const [selectedTab, setSelectedTab] = useState()
  const currentStage = useSelector((globalState) => globalState.auth.currentStage)
  const [showLoadingIcon, setShowLoadingIcon] = useState(true)
  const [tabConfigInfoLoaded, setTabConfigInfoLoaded] = useState(false)
  const [allTabs, setAllTabs] = useState([])
  const [section, setSection] = useState('')
  const [addItemTitleInput, setAddItemTitleInput] = useState('')
  const currentUser = useSelector((globalState) => globalState.auth.userId)
  const [errorText, setErrorText] = useState('')
  const isPortalAdmin = useSelector(selectIsEffectiveAdmin)
  const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin)

  React.useEffect(() => {

    if (isPortalAdmin || isSupportAdmin) {
          getOwnersForAdminUser(function onSuccess(result) {
            const data = result.data.getOwnersForAdminUserRDS
            const owners = JSON.parse(data)
            const ownerSelectOptions = owners.map((owner) => {
              return { label: owner?.owner_name, value: String(owner?.owner_id), owner_identifier: owner?.owner_identifier, owner_type: owner?.owner_type }
            })
            setOwnedTeams(ownerSelectOptions)
            configureGenericAppSync()
            setShowLoadingIcon(false)
          }, function onFailure(response) {
            configureGenericAppSync()
            setShowLoadingIcon(false)
          })
    } else {
        getOwnersByOwnership(currentStage, function onSuccess(result) {
            const data = result.data.getOwnersByOwnership
            const owners = JSON.parse(data)
            const ownerSelectOptions = owners.map((owner) => {
              return { label: owner?.owner_name, value: owner?.owner_id, owner_identifier: owner?.owner_identifier, owner_type: owner?.owner_type }
            })
            setOwnedTeams(ownerSelectOptions)
            configureGenericAppSync()
            setShowLoadingIcon(false)
          }, function onFailure(response) {
            configureGenericAppSync()
            setShowLoadingIcon(false)
          })
    }

    
  }, [currentStage, isPortalAdmin, isSupportAdmin]);

  useEffect(()=> {

    if(selectedTeam?.value) {
        listPreference(
              selectedTeam.value,
              'CLOSE_PORTAL',
              'CLOSE_PORTAL_TABS_CONFIG',
              function onSuccessResponse(response) {
                const preferences = response?.data?.listPreference?.items || [];
        
                const validPreferences = preferences.filter(pref => {
                  if (pref.information) {
                    const information = typeof pref.information === 'string'
                      ? JSON.parse(pref.information)
                      : pref.information;
                    return information;
                  }
                  return false;
                });
        
                setAllTabs(validPreferences)
        
                if (validPreferences?.length > 0) {
                  const info = JSON.parse(validPreferences[0]?.information)
                  if (info?.tabConfiguration?.closePortalTabs) {
                    const tabConfigInfo = info?.tabConfiguration?.closePortalTabs
                    
                    setAllTabs(tabConfigInfo?.filter((tab)=>(tab?.id !== 'AppsLibrary'))?.map((tab)=> ({...tab, value: tab?.id})))
                    setTabConfigInfoLoaded(true)
                  }
                } else {
                  setAllTabs(closePortalDefaultTabs?.filter((tab)=>(tab?.id !== 'AppsLibrary'))?.map((tab)=> ({...tab, value: tab?.id})))
                  setTabConfigInfoLoaded(true)
                }
              },
              function onFailureResponse(error) {
                configureGenericAppSync()
              }
            );
    }

  },[selectedTeam])

  useEffect(() => {
    if(selectedTab?.id) {
        if(selectedTab?.tabType === 'BOARD') {
            setSection(selectedTab?.id)
        } else {
            setSection('')
        }
    }
  },[selectedTab])

  const addItem = async () => {
          if (selectedTeam?.value && selectedTab?.id && section && resourceURL && addItemTitleInput) {
                  setShowLoadingIcon(true)
  
                  let content = {}
                  let stage = currentStage === 'prod' ? '' : 'beta.'
    
                  const url = `https://${stage}bi-central.accounting.amazon.dev${resourceURL}`
                  
                  content["url"] = url
  
                  content = JSON.stringify(content)
                  content = content.replaceAll('"', "'")
                  let columnOffset = {
                      "4": 0,
                      "6": 0
                  }
                  columnOffset = JSON.stringify(columnOffset)
                  columnOffset = columnOffset.replaceAll('"', "'")
                  const isDefault = selectedTeam?.owner_type === "DEFAULT"
                  const input = {
                      "board_item_title": addItemTitleInput,
                      "board_item_content": content,
                      "board_item_content_type": "WEBPAGE",
                      "owner_id": selectedTeam?.value,
                      "is_default": isDefault,
                      "board_page_type": selectedTab?.id,
                      "created_by": currentUser,
                      "last_updated_by": currentUser,
                      "row_span": "2",
                      "column_span": "1",
                      "column_offset": columnOffset,
                      "row_order": Number.MAX_SAFE_INTEGER,
                      "section": section
                  }
                  await addBoardItem(input, function onSuccess(result) {
                      onDismiss()
                      configureGenericAppSync()
                  }, function onFailure(response) {

                      onDismiss()
                      configureGenericAppSync()
                      setShowLoadingIcon(false)
                  })  
          } else {
              setErrorText('All fields are required!')
          }
      }


  return (
    <Modal
      size="large"
      onDismiss={onDismiss}
      visible={visible}
      footer={
        <>
          {errorText && (
            <Alert type="error" statusIconAriaLabel="Error">
              {errorText}
            </Alert>
          )}
          
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={onDismiss}>Cancel</Button>
                  <Button variant="primary" disabled={(!selectedTeam || !selectedTab || !section || !addItemTitleInput)} onClick={addItem}>Add</Button>
              </SpaceBetween>
            </Box>
        </>
      }
      header="Add to Workspace"
    >
      {(showLoadingIcon === false) ? (
        <>
          
            <>
              <Header variant="h3">
                <Box color="text-status-info">Add</Box>
              </Header>
            </>
            {ownedTeams?.length >= 1 ? (<>
            <FormField
                label="Select team"
                stretch
            >
                <Select
                    selectedOption={selectedTeam}
                    onChange={({ detail }) =>
                        setSelectedTeam(detail.selectedOption)
                    }
                    options={ownedTeams}
                    placeholder='Select a team page to add resource'
                />
            </FormField>

            {
                selectedTeam?.value && (
                    <FormField
                label="Select tab"
                stretch
            >
                <Select
                    selectedOption={selectedTab}
                    onChange={({ detail }) =>
                        setSelectedTab(detail.selectedOption)
                    }
                    options={allTabs}
                    placeholder='Select a tab of the page to add resource to'
                />
            </FormField>
                )
            }
            {
                selectedTeam?.value && selectedTab?.id && (
                    <FormField
                label="Provide display name"
                stretch
            >
                <Input onChange={({ detail }) => setAddItemTitleInput(detail.value)}
                    value={addItemTitleInput}
                    placeholder='Display name'
                />
            </FormField>
                )
            }
            {
                selectedTeam?.value && selectedTab?.id && selectedTab?.tabType === 'LIST' && (
                    <FormField
                label="Provide section to add under"
                stretch
            >
                <Input onChange={({ detail }) => setSection(detail.value)}
                    value={section}
                    placeholder='section'
                />
            </FormField>
                )
            }
            </>) :
            <>
            Resources can only be added to Close Portal team pages by page owners, and you are not currently listed as a Primary or Secondary Owner of a team page. If your team doesn’t have a Close Portal page yet, you can create one here: 
            <Link
                external
                fontSize="heading-m"
                href="https://bi-central.accounting.amazon.dev/ClosePortal/Product%20Resources/Page/2?resourceId=41f2100f-517b-4592-af6d-900a3ac0c952"
                variant="primary"
            >
                Create a CP page
            </Link>
            </>
            }
          
        </>
      ) : (
        <>
          <Spinner />Loading...
        </>
      )}
    </Modal>
  );
};

export default AddToCPModal;
